import { managerEnvironmentCommon } from './environment.manager.common';
import { prodGtmConfig } from './gtm.config';

const env: Partial<typeof managerEnvironmentCommon> = {
  gtmConfig: prodGtmConfig,
};
export const environment = Object.assign(managerEnvironmentCommon, env);
